import { Avatar, Badge, DropdownSelect } from "@avenueops/web-components";
import { PlaybookStep } from "@prisma/client";
import { trpc, trpc2 } from "utils/trpc";
import { UserIcon } from "@heroicons/react/24/outline";

interface Props {
  step: PlaybookStep;
  disabled?: boolean;
}

export function PlaybookStepAssigneeDropdown({ step, disabled = false }: Props) {
  const { data, isLoading } = trpc.assignees.list.useQuery();
  const utils = trpc.useContext();
  const utils2 = trpc2.useContext();

  const { mutateAsync } = trpc2.v2.playbookSteps.assign.useMutation({
    onSuccess: async () => {
      utils.processes.getOpenPlaybookSteps.invalidate({ processId: step.workflowProcessId });
      utils2.v2.playbookSteps.listStepsByProcess.invalidate({ processId: step.workflowProcessId });
      utils2.v2.playbookSteps.get.invalidate({ stepId: step.id });
      utils2.v2.playbookSteps.list.invalidate();
      utils2.v2.playbookSteps.countActiveTasks.invalidate();
    },
  });

  const options =
    data?.map((user) => ({
      icon: <Avatar size="SMALL" src={user.image ?? undefined} />,
      label: `${user.firstName} ${user.lastName}`,
      value: user.id,
    })) ?? [];

  return (
    <DropdownSelect
      type="BUTTON"
      size="SMALL"
      disabled={disabled}
      options={options}
      name={`${step.id}_${step.workflowProcessId}_assignee`}
      selectedValue={step.assigneeId ?? undefined}
      IndicatorIcon={UserIcon}
      placeholder="No assignee"
      onChange={(value) => {
        mutateAsync({ assigneeId: value ?? null, stepId: step.id });
      }}
    />
  );
}
